export default __webpack_public_path__ + "static/media/cyprus.c4399814.svg";